module.exports = "<div class=\"page-title\">\n  <i class=\"fa fa-bar-chart-o\"></i>\n  <h3>Dashboard</h3>\n</div>\n\n\n<div class=\"row\">\n  <div class=\"grid simple\">\n    <div class=\"grid-title no-border\">\n      <h4>Produkty w bazie</h4>\n    </div>\n    <div class=\"grid-body no-border\">\n        \n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/dashboard/dashboard.component.html
// module id = ../../../../../src/app/main/dashboard/dashboard.component.html
// module chunks = 1